import React from 'react';
import PropTypes from 'prop-types';
import { last } from 'lodash';
import { TableRow } from 'smartsuite-ui/lib/table/TableRow';
import { Table } from 'smartsuite-ui/lib/table/Table';
import { TableCell } from 'smartsuite-ui/lib/table/TableCell';
import { TableVirtuoso } from 'react-virtuoso';
import { TableHeaderCellSortable } from './TableHeaderCellSortable';
import DraggableHeader from './DraggableHeader';

function getHeaderColumnStyles(column, fixedColumnsWidthTotal, width) {
    const styles = {
        width,
        maxWidth: width,
        minWidth: width,
    };

    if (column.isFixed) {
        styles.position = 'sticky';
        styles.left = fixedColumnsWidthTotal;
        styles.zIndex = 1;
    }

    return styles;
}

export function VirtuosoTable(props) {
    const lastHeaderRow = props.hasMultipleHeaderRows
        ? last(props.columns)
        : props.columns;

    function renderHeaderRow(headerRow, renderDraggableIcon, getColumnWidth) {
        let fixedColumnsWidthTotal = 0;
        return (
            <TableRow>
                {headerRow.map((headerColumn) => {
                    const width = getColumnWidth(headerColumn.dataKey);
                    const columnStyles = getHeaderColumnStyles(
                        headerColumn,
                        fixedColumnsWidthTotal,
                        width
                    );

                    fixedColumnsWidthTotal += width;
                    return (
                        <TableHeaderCellSortable
                            key={headerColumn.dataKey}
                            style={columnStyles}
                            columnName={headerColumn.dataKey}
                            sortObject={props.sortObject}
                            onSort={props.onSort}
                            renderDraggableIcon={renderDraggableIcon}
                        >
                            {props.labels[headerColumn.dataKey] ??
                                headerColumn.dataKey}
                        </TableHeaderCellSortable>
                    );
                })}
            </TableRow>
        );
    }

    function buildFixedHeaderContent(renderDraggableIcon, getColumnWidth) {
        if (props.hasMultipleHeaderRows) {
            return props.columns.map((headerRow) =>
                renderHeaderRow(headerRow, renderDraggableIcon, getColumnWidth)
            );
        }

        return renderHeaderRow(
            props.columns,
            renderDraggableIcon,
            getColumnWidth
        );
    }

    function renderItemContent(index) {
        const row = props.data[index];

        let fixedColumnsWidthTotal = 0;

        return lastHeaderRow.map((headerColumn, colIndex) => {
            const dataPoint = row[headerColumn.dataKey];
            /* eslint-disable indent */
            const columnStyles = headerColumn.isFixed
                ? {
                      position: 'sticky',
                      left: fixedColumnsWidthTotal,
                      backgroundColor: '#f5f5f5',
                  }
                : {};
            /* eslint-enable */

            fixedColumnsWidthTotal += headerColumn.width;

            return (
                <TableCell
                    key={`${index}-${colIndex}`} // eslint-disable-line react/no-array-index-key
                    style={columnStyles}
                >
                    {dataPoint}
                </TableCell>
            );
        });
    }

    return (
        <DraggableHeader columns={lastHeaderRow}>
            {({ renderDraggableIcon, getColumnWidth }) => (
                <TableVirtuoso
                    totalCount={props.data.length}
                    components={{
                        Table,
                        TableRow,
                    }}
                    fixedHeaderContent={() =>
                        buildFixedHeaderContent(
                            renderDraggableIcon,
                            getColumnWidth
                        )
                    }
                    itemContent={renderItemContent}
                />
            )}
        </DraggableHeader>
    );
}

VirtuosoTable.propTypes = {
    data: PropTypes.instanceOf(Array).isRequired,
    columns: PropTypes.instanceOf(Array).isRequired,
    labels: PropTypes.instanceOf(Object).isRequired,
    onSort: PropTypes.func.isRequired,
    sortObject: PropTypes.instanceOf(Object).isRequired,
    hasMultipleHeaderRows: PropTypes.bool,
};
VirtuosoTable.defaultProps = { hasMultipleHeaderRows: false };
